import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CoachBotDataAccessCoreModule} from '@coach-bot/data-access/core';
import {SkillStackService} from './services/skill-stack.service';

@NgModule({
  imports: [CommonModule, CoachBotDataAccessCoreModule], providers: [SkillStackService]
})
export class CoachBotDataAccessMathSkillsStackModule {}
